import { render, staticRenderFns } from "./EditLicenseSidebar.vue?vue&type=template&id=1367ff9b&scoped=true"
import script from "./EditLicenseSidebar.vue?vue&type=script&lang=js"
export * from "./EditLicenseSidebar.vue?vue&type=script&lang=js"
import style0 from "./EditLicenseSidebar.vue?vue&type=style&index=0&id=1367ff9b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1367ff9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1367ff9b')) {
      api.createRecord('1367ff9b', component.options)
    } else {
      api.reload('1367ff9b', component.options)
    }
    module.hot.accept("./EditLicenseSidebar.vue?vue&type=template&id=1367ff9b&scoped=true", function () {
      api.rerender('1367ff9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/OrganisationDetails/Licenses/EditLicenseSidebar.vue"
export default component.exports